// Legacy memory-metrics URL — moved to `/agents/memories/metrics` with the
// unified Agents page (2026-07 nav review).
import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from '../../../lib/constants';

export const Route = createFileRoute('/memory/metrics/')({
  beforeLoad: () => {
    throw redirect({ to: routes.MEMORY_METRICS, replace: true });
  },
  component: () => null,
});
